import axios from "axios";

export const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
export const api = axios.create({ baseURL: API, withCredentials: true });

const GUEST_KEY = "lumacofono_guest_token";
let guestPromise = null;

export function getGuestToken() {
  return localStorage.getItem(GUEST_KEY);
}

export async function ensureGuest() {
  const t = getGuestToken();
  if (t) return t;
  if (!guestPromise) {
    guestPromise = axios
      .post(`${API}/guest`, {}, { withCredentials: true })
      .then((r) => {
        localStorage.setItem(GUEST_KEY, r.data.guest_token);
        return r.data.guest_token;
      })
      .finally(() => {
        guestPromise = null;
      });
  }
  return guestPromise;
}

api.interceptors.request.use(async (config) => {
  try {
    const needsGuest = config.method === "post" && /\/(vote|proposals)$/.test(config.url || "");
    const token = needsGuest ? await ensureGuest() : getGuestToken();
    if (token) config.headers["X-Guest-Token"] = token;
  } catch {
    /* lettura possibile anche senza ID anonimo */
  }
  return config;
});

api.interceptors.response.use(
  (r) => r,
  async (error) => {
    const cfg = error.config;
    if (error.response?.status === 401 && cfg && !cfg._retry && !cfg.url.includes("/auth/")) {
      cfg._retry = true;
      try {
        await axios.post(`${API}/auth/refresh`, {}, { withCredentials: true });
        return api(cfg);
      } catch {
        /* sessione scaduta */
      }
    }
    return Promise.reject(error);
  }
);

export function errMsg(e) {
  const d = e?.response?.data?.detail;
  if (d == null) return e?.message || "Qualcosa è andato storto. Riprova.";
  if (typeof d === "string") return d;
  if (Array.isArray(d)) return d.map((x) => (x && typeof x.msg === "string" ? x.msg : JSON.stringify(x))).join(" ");
  if (typeof d.msg === "string") return d.msg;
  return String(d);
}

export function fmtDate(s) {
  if (!s) return "";
  try {
    return new Date(s).toLocaleString("it-IT", { dateStyle: "medium", timeStyle: "short" });
  } catch {
    return s;
  }
}

export const ESITO_LABEL = { aperto: "Mistero ancora irrisolto", chiuso: "Scelte chiuse", risolto: "Rivelato nel manga" };
export const STATO_LABEL = { bozza: "Bozza", pubblicato: "Pubblicato", archiviato: "Archiviato" };
